export interface CreditCardAssigneeConstructor {
  id: number
  firstName: string
  lastName: string
  email: string
  position: Nullable<string>
  profileImage: Nullable<string>
}

// Minimal nested Summary reference embedded in credit card rows — created
// instead of constructing the deprecated core/entities/internal/User, whose
// constructor demands fields the creditcards endpoint doesn't return.
export class CreditCardAssignee {
  readonly id: number
  readonly firstName: string
  readonly lastName: string
  readonly email: string
  readonly position: Nullable<string>
  readonly profileImage: Nullable<string>

  constructor(data: CreditCardAssigneeConstructor) {
    this.id = data.id
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.email = data.email
    this.position = data.position
    this.profileImage = data.profileImage
  }

  // Assigned-user row display name (BHV-020)
  get fullName(): string {
    return `${this.firstName} ${this.lastName}`.trim()
  }
}
